import BaseAlgoliaSearch from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { SearchSettings } from '@module/Algolia/resources/js/search/types';
import { transformProduct, transformStore } from './transformers';

let instance: AlgoliaSearch | null = null;

export default class AlgoliaSearch extends BaseAlgoliaSearch {
  static getInstance(): AlgoliaSearch {
    if (!instance) {
      instance = new AlgoliaSearch();
    }

    return instance;
  }

  protected getMainSearchSettings(): SearchSettings[] {
    return [...super.getMainSearchSettings(), this.getSuggestionsSettings(5)];
  }

  protected getProductsSettings(): SearchSettings {
    return {
      ...super.getProductsSettings(),
      hitsPerPage: 12,
      transformer: transformProduct,
    };
  }

  protected getArticlesSettings(): SearchSettings {
    return {
      ...super.getArticlesSettings(),
      hitsPerPage: 12,
    };
  }

  protected getStoresSettings(): SearchSettings {
    return {
      ...super.getStoresSettings(),
      hitsPerPage: 12,
      transformer: transformStore,
    };
  }

  isAnalyticsEnabled(): boolean {
    return AlgoliaSearch.isEnabled();
  }
}

export const algoliaSearch = AlgoliaSearch.getInstance();
